module.exports = __webpack_public_path__ + "static/media/level1-1.6479412d.mp3";